export default "__VITE_ASSET__112ad10f__"